import { useState } from "react";
import BusinessSummary from "../../components/BusinessSummary";
import BusinessForm from "../../components/BusinessForm";
import { runBusinessAssessment } from "../../api/diagnosticsApi";
import { Loader2, Activity } from "lucide-react";

export default function BusinessAssessmentTool() {
  const [report, setReport] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  async function runDiagnostic(answers: any) {
    setIsLoading(true);
    try {
      const data = await runBusinessAssessment(answers);
      setReport(data);
    } catch (err) {
      console.error("Error running business diagnostic:", err);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="min-h-screen pt-10 p-6 md:p-8 lg:p-10 md:ml-0">
      <header className={`mt-5 mb-8 flex items-center justify-between ${!report || isLoading ? "max-w-2xl mx-auto justify-center text-center" : ""}`}>
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2 leading-tight mb-0">
            <Activity className="text-indigo-600" size={24} />
            {report && !isLoading ? "Diagnostic Results" : "Business Diagnostics"}
          </h1>
          <p className="text-slate-500 text-sm mt-1 text-left">
            {report && !isLoading 
              ? "Review your personalized business maturity and scalability analysis below."
              : "Evaluate your operational efficiency and digital scalability with our diagnostic engine."}
          </p>
        </div>
      </header>

      {!report && !isLoading && (
        <div className="max-w-2xl mx-auto">
          <BusinessForm onSubmit={runDiagnostic} />
        </div>
      )}

      {isLoading && (
        <div className="flex flex-col items-center justify-center py-20 animate-pulse">
          <Loader2 className="w-12 h-12 text-indigo-600 animate-spin mb-4" />
          <p className="text-slate-500 font-medium text-lg">Analyzing your business structure...</p>
        </div>
      )}

      {report && !isLoading && (
        <div className="mt-8">
          <BusinessSummary
            overallPercentage={report.overallPercentage}
            visualIndicator={report.visualIndicator || report.grade}
            categoryScores={report.categoryScores}
            report={report.summaryReport}
            recommendations={report.recommendations}
            services={report.ctaServices}
          />
        </div>
      )}
    </div>
  );
}